import { useFavoriteSubAccounts } from '@talos/kyoko';
import { useMemo } from 'react';
import { useSubAccounts } from '../../providers';

export function useSubAccountSearchSelectOptions() {
  const { tradableSubAccounts } = useSubAccounts();
  const { favoriteSubAccounts } = useFavoriteSubAccounts();
  const favoriteSubAccountsSet = useMemo(() => new Set(favoriteSubAccounts), [favoriteSubAccounts]);

  const options = useMemo(() => {
    if (!tradableSubAccounts) {
      return [];
    }
    return tradableSubAccounts.toSorted((a, b) => {
      if (favoriteSubAccountsSet.has(a.Name) && !favoriteSubAccountsSet.has(b.Name)) {
        return -1;
      }
      if (!favoriteSubAccountsSet.has(a.Name) && favoriteSubAccountsSet.has(b.Name)) {
        return 1;
      }
      return a.Name.localeCompare(b.Name);
    });
  }, [tradableSubAccounts, favoriteSubAccountsSet]);

  return options;
}
